export default __webpack_public_path__ + "static/media/logo.41337d84.png";